import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item_subtitle = _resolveComponent("v-list-item-subtitle")!
  const _component_v_list_item = _resolveComponent("v-list-item")!

  return (_openBlock(), _createBlock(_component_v_list_item, {
    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.detail(_ctx.article))),
    key: _ctx.article.ArtikelNr,
    class: "article-item py-5"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_list_item_title, { class: "text-truncate max-width-text" }, {
        default: _withCtx(() => [
          _createElementVNode("span", null, _toDisplayString(_ctx.article.Bezeichnung1), 1)
        ], undefined, true),
        _: 1
      }),
      (_ctx.article.Bezeichnung2)
        ? (_openBlock(), _createBlock(_component_v_list_item_subtitle, { key: 0 }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.article.ArtikelNr), 1)
            ], undefined, true),
            _: 1
          }))
        : _createCommentVNode("", true),
      _createVNode(_component_v_list_item_subtitle, null, {
        default: _withCtx(() => [
          _createElementVNode("div", null, _toDisplayString(_ctx.article.EANCode), 1)
        ], undefined, true),
        _: 1
      })
    ], undefined, true),
    _: 1
  }))
}